import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "col-lg-3 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { value: null }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-3 col-sm-6 text-end mt-4" }
const _hoisted_12 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo Reporte", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.reportType) = $event)),
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("option", { value: "general" }, "Data General", -1 /* HOISTED */),
                    _createElementVNode("option", { value: "logins" }, "Data Logeos", -1 /* HOISTED */)
                  ]), 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.reportType]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.tournamentId) = $event)),
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.tournamentId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getReport()), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Generar Reporte ")
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ])
      ])
    ])
  ]))
}